var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"white--text",style:([
    {
      padding: `2px 16px`,
      backgroundColor: '#ac832d',
      borderRadius: '24px',
      boxShadow: 'none',
    },
    _vm.$breakpoints.mdAndUp && {
      padding: `${_vm.$getScaledCssValue('8px')} ${_vm.$getScaledCssValue('38px')}`,
      borderRadius: _vm.$getScaledCssValue('7px'),
    },
  ]),attrs:{"type":"submit"}},[_c('div',{class:{
      'text-p4 white--text': true,
      'font-weight-light': _vm.$breakpoints.smAndDown,
    },style:([
      { textTransform: 'none' },
      _vm.$breakpoints.mdAndUp && { textTransform: 'uppercase' },
    ])},[_vm._v(" "+_vm._s(_vm.$t("SearchMsg"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }